import {
  BoltIcon,
  CurrencyDollarIcon,
  SpeakerWaveIcon,
  WrenchScrewdriverIcon
} from '@heroicons/react/24/outline';
import { SystemScoreCategoryScoresType } from 'data/types';
import { ComponentType, SVGProps } from 'react';

export type ScoreCategoryKey = keyof SystemScoreCategoryScoresType;

export type ScoreCategoryDefinition = {
  key: ScoreCategoryKey;
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
};

export const SCORE_CATEGORY_DEFINITIONS: ReadonlyArray<ScoreCategoryDefinition> =
  [
    { key: 'comfortPerformance', label: 'Comfort', icon: BoltIcon },
    {
      key: 'installationDifficulty',
      label: 'Installation',
      icon: WrenchScrewdriverIcon
    },
    { key: 'noise', label: 'Noise', icon: SpeakerWaveIcon },
    { key: 'value', label: 'Value', icon: CurrencyDollarIcon }
  ];
